<template>
  <div style="border: 1px solid #DFDFDF; border-radius: 6px; padding: 8px 8px 8px 4px;">
    <Bar :chart-data="chartData" :chart-options="chartOptions" style="height: 250px"/>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  components: {
    Bar
  },
  props:{
    graphData: {
      required: true,
    }
  },
  computed:{
    pipelineLeadsData(){
      return this.getGraphData('pipeline_leads_series');
    },
    siteVisitLeadsData(){
      return this.getGraphData('site_visit_leads_series');
    },
    bookingLeadsData(){
      return this.getGraphData('booking_leads_series');
    },
    pipelineLeadsInitialData() {
      return this.getGraphData('initial_pipeline_series');
    },
    labels(){
      const data = this.graphData?.pipeline_leads_series;
      return data ? Object.keys(data).map(date => this.$moment(date).format('DD MMM YY')):[];
    },
    pipelineAmount(){
      const data = this.graphData?.pipeline_amount_series;
      return data ? Object.values(data) : [];
    },
    initialPipelineAmount(){
      const data = this.graphData?.initial_pipeline_amount_series;
      return data ? Object.values(data) : [];
    },
    chartData(){
      return {
        labels: this.labels,
        datasets: [
          {
            label: 'INITIAL PIPELINE LEADS',
            data: [...this.pipelineLeadsInitialData],
            backgroundColor: '#539FBB',
            skipNull: true
          },

          {
            label: 'EOD PIPELINE LEADS',
            data: [...this.pipelineLeadsData],
            backgroundColor: '#2C6175',
            skipNull: true,
          },
          {
            label: 'SITE VISIT LEADS',
            data: [...this.siteVisitLeadsData],
            backgroundColor: '#A4A834',
            skipNull: true
          },
          {
            label: 'BOOKING LEADS',
            data: [...this.bookingLeadsData],
            backgroundColor: '#cf173f',
            skipNull: true
          }
        ]
      }
    }
  },
  data() {
    let vm = this;
    return {
      color:['#539FBB','#2C6175','#A4A834','#cf173f'],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: 'index'
        },
        plugins: {
          legend: {
            display: true,
            labels: {
            usePointStyle: true,
            pointStyle: 'rectRounded',
            }
          },
           tooltip: {
						position: "nearest",
						xAlign: "bottom",
            bodySpacing: 5,
            backgroundColor: '#fff',
            titleColor: '#030303',
            usePointStyle: true,
            borderColor:'rgba(0, 0, 0, 0.06)',
            borderWidth: 1,
            titleColor: "#585858",
            titleMarginBottom: 8,
            padding: 8,
            cornerRadius: 4,
            caretSize: 0,
            displayColors: true,
            boxWidth: 8,
            boxHeight: 8,
            titleFont:{
              size: 11,
              lineHeight: 1.5,
              weight: 400,
            },
            bodyFont:{
              size: 11,
              lineHeight: 1,
              weight: 400
            },
            callbacks: {
              labelColor: function (context) {
                return {
                  backgroundColor: vm.color[context.datasetIndex],
                  borderWidth: 1
                };
              },
              labelTextColor: function () {
                return '#333333';
              },
              beforeTitle: function (context) {
                return `${context[0].label}`;
              },
              afterTitle: function (context) {
                return `EOD Pipeline Amount:${vm.pipelineAmount[context[0].dataIndex]}`;
              },
              title: function (context) {
                return `Initial Pipeline Amount: ${vm.initialPipelineAmount[context[0].dataIndex]}`;
              },
            }
          },
        },
        scales: {
          x: {
            grid: {
              display: false,
            },
            ticks: {
              display: true
            },
          },
          y: {
            beginAtZero: true,
            grid: {
              display: true,
            },
            title: {
              display: true,
              text: 'PIPELINE LEADS'
            },
          }
        },
      }
    };
  },
  methods:{
    // if value is zero convert 0 to null
    getGraphData(key) {
      const data = this.graphData?.[key];
      return data ? Object.values(data).map(v => v === 0 ? null : v) : [];
    }
  }
};
</script>
